function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { AccordionItem, MinusCircleIcon, PlusCircleIcon } from '@cmsgov/design-system';
import { t } from '../i18n';
AccordionItem.defaultProps = _objectSpread(_objectSpread({}, AccordionItem.defaultProps), {}, {
  closeIcon: /*#__PURE__*/React.createElement(MinusCircleIcon, {
    className: "ds-c-accordion__button-icon",
    title: t('accordion.close'),
    ariaHidden: false
  }),
  openIcon: /*#__PURE__*/React.createElement(PlusCircleIcon, {
    className: "ds-c-accordion__button-icon",
    title: t('accordion.open'),
    ariaHidden: false
  })
});
export default AccordionItem;